import cloneDeep from 'lodash/cloneDeep.js';
import traverse from 'traverse';

// prettier-ignore
export type DateToStringRecord<Input extends Record<string, any>> = {
  [key in keyof Input]: 
    Input[key] extends Date ? string
    : Input[key] extends Date | undefined ? string | undefined
    : Input[key] extends Array<any> ? DateToString<Input[key]>
    : Input[key] extends Array<any> | undefined ? DateToString<Input[key]> | undefined
    : Input[key] extends Record<string, any> ? DateToString<Input[key]>
    : Input[key] extends Record<string, any> | undefined ? DateToString<Input[key]> | undefined
    : Input[key];
}

// prettier-ignore
export type DateToString<Input extends Array<any> | Record<string, any>> = 
  | Input extends Array<infer A> ? 
      (A extends Array<any> | Record<string, any> ? Array<DateToString<A>> : Array<A>) // Array<A>)
    : DateToStringRecord<Input>;

export function convertDatesToStrings<Input extends Array<any> | Record<string, any>>(obj: Input): DateToString<Input> {
  const clonedObject = cloneDeep(obj);

  traverse(clonedObject).forEach(function (this: traverse.TraverseContext, value: any) {
    if (value instanceof Date) {
      this.update(value.toISOString());
    }
  });

  return clonedObject as any;
}

export function deleteNullProperties<T extends object>(obj: T): T {
  const clonedObject = cloneDeep(obj);

  traverse(clonedObject).forEach(function (this: traverse.TraverseContext, value: any) {
    if (value === null || value === undefined) {
      this.delete();
    }
  });

  return clonedObject;
}
